"use client";

import { FormationProvider } from "@fanduel/formation-react-components";
import { PropsWithChildren } from "react";
import { formationThemes } from "@/utils/formationTheme";

export default function FormationThemeProvider({
  children,
}: PropsWithChildren) {
  return (
    <FormationProvider theme={formationThemes.fanduel}>
      {children}
    </FormationProvider>
  );
}
